module.exports = __webpack_public_path__ + "img/sl2.468e56db.png";